import { render, staticRenderFns } from "./otherContractMag.vue?vue&type=template&id=51830a08&scoped=true&"
import script from "./otherContractMag.vue?vue&type=script&lang=js&"
export * from "./otherContractMag.vue?vue&type=script&lang=js&"
import style0 from "./otherContractMag.vue?vue&type=style&index=0&id=51830a08&scoped=true&lang=css&"
import style1 from "./otherContractMag.vue?vue&type=style&index=1&id=51830a08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51830a08",
  null
  
)

export default component.exports